import setFilters from 'store/reducer-utils/setFilters'
import { updateObject } from 'utils/updateObject'
import {
  CHANGE_ACTIVE_WALLET_ID,
  RESET_WALLET_TRANSACTIONS,
  RESET_WALLETS,
  RESET_WALLETS_FILTERS,
  SET_WALLET_TRANSACTIONS,
  SET_WALLETS,
  SET_WALLETS_FILTERS,
} from 'modules/Finance/Wallets/store/types'

const initialState = {
  filters: null,
}

const setWallets = (state, action) => ({
  ...state,
  wallets: {
    ...state.wallets,
    ...action.payload,
  },
})

const resetWallets = () => ({
  ...initialState,
})

const setWalletTransactions = (state, action) => ({
  ...state,
  transactions: {
    ...state.transactions,
    ...action.payload,
  },
})

const resetWalletTransactions = (state) => ({
  ...state,
  transactions: {
    ...initialState.transactions,
  },
})

const changeActiveWalletID = (state, action) => ({
  ...state,
  activeWalletID: action.payload,
})

const setWalletFilters = (state, action, force = false) => {
  const filteredPayload =
    state?.filters && !force
      ? [...action.payload].filter(
          (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
        )
      : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const resetWalletFilters = (state, action) => updateObject(state, { filters: action.payload })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WALLETS:
      return setWallets(state, action)
    case RESET_WALLETS:
      return resetWallets(state)
    case RESET_WALLETS_FILTERS:
      return resetWalletFilters(state, action)
    case SET_WALLETS_FILTERS:
      return setWalletFilters(state, action)
    case SET_WALLET_TRANSACTIONS:
      return setWalletTransactions(state, action)
    case RESET_WALLET_TRANSACTIONS:
      return resetWalletTransactions(state)
    case CHANGE_ACTIVE_WALLET_ID:
      return changeActiveWalletID(state, action)

    default:
      return state
  }
}

export default reducer
